$(() => {
  const buttonContainer = document.querySelector('.subscribe-container');
  const buttonText = document.querySelector('.subscribe-action');
  if (buttonText === null) return;

  buttonText.innerHTML = I18n.t('shared.footer.subscribe');

  function triggerSubscribeSubmit() {
    buttonContainer.querySelector('button').click();
  }
  buttonContainer.addEventListener('click', triggerSubscribeSubmit);
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/animate_subscribe_success.js